module.exports = function getResource(label) {
    const resources = {
        emailLabel: 'Courriel',
        nameLabel: 'Nom',
        editLink: 'Modifier'
    };

    return resources[label];
};
